<template>
  <v-row dense>
    <v-col cols="12">
      <PCQuickLook :case-outputs="caseOutputs" :input-case="inputCase" :horizontal="true" />
    </v-col>
    <v-divider v-if="displayDivider" vertical inset></v-divider>
    <v-col cols="12">
      <PCDashboard :case-outputs="caseOutputs" :input-case="inputCase" :logoUrl="logoUrl" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "OutputPCDashboard",
  components: {
    PCDashboard: () => import("@/components/dashboards/PCDashboard.vue"),
    PCQuickLook: () => import("@/components/dashboards/PCQuickLook.vue"),
  },
  mixins: [],
  props: {
    caseOutputs: { type: Object, required: true },
    inputCase: { type: Object, required: true },
    logoUrl: { type: String, required: true },
  },
  data() {
    return {};
  },
  computed: {
    displayDivider() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
